import React, {useEffect, useState} from 'react'
import {Scrollbar} from 'react-scrollbars-custom'
import actions from 'redux-auto'
import Header from './Header'
import Navigation from './o/Navigation/Root'
import {startApplicationInsights} from '#helpers/applicationInsights'
import {makeBodyVisible} from '#helpers/document'
import ErrorBoundry from '#components/ErrorBoundry'
import TopLevelErrorModal from '#components/m/TopLevelErrorModal/container'
import ScrollToTop from './ScrollToTop'
import useCurrentUser from '#hooks/store/useCurrentUser'
import {SignalRConnector} from './SignalRConnector'
import {AzubiGuideRoutes} from '#config/azubiGuideRoutes'
import {Outlet, RouterProvider, ScrollRestoration, createBrowserRouter, useLocation} from 'react-router-dom'
import PrivacyPolicy from '#components/o/PrivacyPolicy/container'
import Filter from '#components/o/Filter/Filter.js'
import {useAuth} from 'oidc-react'
import CookieBanner from './o/CookieBanner/CookieBanner'

const router = createBrowserRouter([{path: '*', element: <Root />}])

export default function App() {
  return <RouterProvider router={router} />
}

function Root() {
  return <AzubiGuideRoutes wrapper={RoutesWrapper()} />
}

export function RoutesWrapper() {
  const [appInsights, setAppInsights] = useState(undefined)

  useEffect(() => {
    makeBodyVisible()
    setAppInsights(startApplicationInsights())
  }, [])

  const {isLoggedIn, role, acceptedPrivacyPolicy} = useCurrentUser()
  const needsToAcceptPrivacyPolicyAfterLogin = isLoggedIn && !acceptedPrivacyPolicy

  useLoadInitialUser()
  useRenewTokenErrorHandling()

  const location = useLocation()

  const scrollbarRef = React.createRef()

  return (
    <ErrorBoundry appInsights={appInsights}>
      <ScrollToTop scrollbarRef={scrollbarRef}>
        <div className="wrapper">
          {isLoggedIn && !needsToAcceptPrivacyPolicyAfterLogin && <Header />}
          {needsToAcceptPrivacyPolicyAfterLogin && <PrivacyPolicy />}
          {!needsToAcceptPrivacyPolicyAfterLogin && <CookieBanner />}
          <div className="content">
            {isLoggedIn && !needsToAcceptPrivacyPolicyAfterLogin && <Navigation />}

            <Scrollbar className="main__wrap" ref={scrollbarRef}>
              {isLoggedIn && !needsToAcceptPrivacyPolicyAfterLogin && role !== 'azubi' && <Filter />}
              <main>
                <TopLevelErrorModal appInsights={appInsights} />
                {!needsToAcceptPrivacyPolicyAfterLogin && <Outlet currentUserRole={role} />}
              </main>
              <ScrollRestoration />
            </Scrollbar>
          </div>
        </div>
      </ScrollToTop>

      <SignalRConnector />
    </ErrorBoundry>
  )
}

function useLoadInitialUser() {
  const auth = useAuth()
  const id = auth?.userData?.profile?.preferred_username
  const loadInitialUser = async () => {
    if (id) {
      let result = await actions.authentication.loadInitialUser({id})
    }
  }

  useEffect(() => {
    loadInitialUser()
  }, [id])
}

function useRenewTokenErrorHandling() {
  const auth = useAuth()

  useEffect(() => {
    const handleSilentRenewError = e => {
      auth.signOutRedirect()
    }
    auth.userManager.events.addSilentRenewError(handleSilentRenewError)

    return () => auth.userManager.events.removeSilentRenewError(handleSilentRenewError)
  }, [auth.userManager])
}
